import { Wallet } from './../types/enums.js';
export const isEvmWallet = (wallet) => [
    Wallet.Magic,
    Wallet.Rabby,
    Wallet.BitGet,
    Wallet.Ledger,
    Wallet.Phantom,
    Wallet.Rainbow,
    Wallet.Turnkey,
    Wallet.Metamask,
    Wallet.OkxWallet,
    Wallet.PrivateKey,
    Wallet.TrezorBip32,
    Wallet.TrezorBip44,
    Wallet.TrustWallet,
    Wallet.LedgerLegacy,
    Wallet.WalletConnect,
    Wallet.CosmostationEth,
].includes(wallet);
export const isCosmosWallet = (wallet) => !isEvmWallet(wallet);
export const isEvmBrowserWallet = (wallet) => [
    Wallet.Rabby,
    Wallet.BitGet,
    Wallet.Phantom,
    Wallet.Rainbow,
    Wallet.Metamask,
    Wallet.OkxWallet,
    Wallet.TrustWallet,
].includes(wallet);
export const isCosmosBrowserWallet = (wallet) => [
    Wallet.Leap,
    Wallet.Keplr,
    Wallet.Ninji,
    Wallet.OWallet,
    Wallet.Cosmostation,
].includes(wallet);
export const isEip712V2OnlyWallet = (wallet) => [
    Wallet.Magic,
    Wallet.Phantom,
    Wallet.Metamask,
    Wallet.WalletConnect,
].includes(wallet);
export const isCosmosAminoOnlyWallet = (wallet) => [Wallet.LedgerCosmos].includes(wallet);
